module.exports = __webpack_public_path__ + "img/e695265.jpg";